import federatieApi from "../../../api/federatieApi";
import transactionApi from "../../../api/transactieApi";
import redirector from "../../../util/redirector";
import { showToastrSuccess } from "../../../util/toastr";
import mergeDeep from "../../../util/mergeDeep";
import { isValidGUID } from "../../../util/guid";
import { TransactionDomainEnum, UserTypes } from "../../../constants/DomainConstants";
import SecurityApi from "../../../api/shared/securityApi";

export default class OverzichtPageHelper {
	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		this.loadUserSession();
		this.context.props.setUserType(UserTypes.FEDERATIEMEDEWERKER);
	}

	setFederatie() {
		const context = this.context;
		const state = context.state;
		const props = context.props;
		const federatieId = props.federaties.length === 1 ? props.federaties[0].id : state.selectedFederatieId;
		const federatie = mergeDeep({}, props.federaties.find(f => f.id === federatieId));
		const ajaxActions = context.props.ajaxActions;

		if (federatie && federatie.id) {
			ajaxActions.started();

			SecurityApi.switchOrganisatie(federatie.ondernemingsnummer).then(() => {
				ajaxActions.ended();
			})
				.catch((ex) => {
					context.props.throwException(ex);
				});

			props.setCurrentOrganisation(federatie);

			let activePage = state.filter ? state.filter.pageNo : 1;
			this.loadSportclubPage(activePage, "Name");
			this.loadOpenAanvragen();
		}
		else {
			context.setState({
				sportclubModels: [],
				filter: {
					pageNo: 1,
					pageSize: 250,
					orderBy: "Name",
					ascending: true,
					naam: null,
					locatie: null,
					sporttak: null,
					poId: null,
					telefoonorgsm:null,
					website:null,
					email:null,
					ondernemingsnummer: null
				},
				totalItems: 0,
				totalPages: 1,
				openAanvragenModels: []
			});
		}
	}

	changePageSize(pageSize) {
		let filter = mergeDeep({}, this.context.state.filter);
		filter.pageSize = pageSize;
		this.context.setState({
			filter: filter
		}, () => this.loadSportclubPage());
	}

	loadSportclubPage(pageNummer, orderBy, onSort) {
		const context = this.context;
		const state = context.state;
		const props = context.props;
		const ajaxActions = context.props.ajaxActions;
		const federatieId = props.federaties.length === 1 ? props.federaties[0].id : state.selectedFederatieId;
		const filter = state.filter;

		let sortBy = "Name";
		if (orderBy || filter.orderBy) {
			sortBy = orderBy ? orderBy : filter.orderBy;
		}

		let ascending = filter.ascending;
		if (filter.orderBy === sortBy && onSort) {
			ascending = !filter.ascending;
		}

		filter.pageNo = pageNummer ? pageNummer : 1;
		filter.orderBy = sortBy;
		filter.ascending = ascending;

		ajaxActions.started();

		federatieApi.getSportclubsByFederatieByFilter(federatieId, filter)
			.then((response) => {
				ajaxActions.ended();
				if(response.data.hasValidationErrors){
					context.setState({
						errors: response.data.validationResults,
						filter: filter
					});
				}else{
					let item = response.data.item;
					let models = item.page.items;
					filter.pageNo = item.pageNo;
					filter.pageSize = item.pageSize;
					let totalItems = item.page.totalItems;
					let totalPages = item.page.totalPages;
					let foundPoIdBelongsToFederatie = true;
					if(totalItems === 1 && models[0].belongsToFederatie === false){
						foundPoIdBelongsToFederatie = false;
					}
					context.setState({
						errors: {},
						sportclubModels: models,
						filter: filter,
						totalItems,
						totalPages,
						foundPoIdBelongsToFederatie
					});
				}

			})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 406) {
					context.props.throwException("Sportfederatie niet gevonden", true);
				}
				else {
					context.props.throwException(ex);
				}
			});
	}

	loadOpenAanvragen() {
		const context = this.context;
		const state = context.state;
		const props = context.props;
		const ajaxActions = props.ajaxActions;
		const federatieId = props.federaties.length === 1 ? props.federaties[0].id : state.selectedFederatieId;

		ajaxActions.started();

		federatieApi.getOpenAanvragenByFederatie(federatieId)
			.then((response) => {
				ajaxActions.ended();

				context.setState({
					openAanvragenModels: response.data
				});
			})
			.catch(() => {
				ajaxActions.failed();
			});
	}

	loadLayout() {
		const context = this.context;
		const props = context.props;
		props.loadOverzichtLayout();
	}

	loadUserSession() {
		const context = this.context;
		const props = context.props;

		if (props.federaties.length === 1 || props.federatieId) {
			if (props.federatieId) {
				context.setState({
					selectedFederatieId: props.federatieId
				}, () => {
					this.setFederatie();
				});
			}
			else {
				this.setFederatie();
			}
		}
	}

	sortTable(index) {
		let activePage = 1;

		switch (index) {
			case 0:
				this.loadSportclubPage(activePage, "Name", true);
				break;
			case 1:
				this.loadSportclubPage(activePage, "Gemeente", true);
				break;
			case 2:
				this.loadSportclubPage(activePage, "IdentificatieCode", true);
				break;
			default:
				break;
		}
	}

	copyPoId(poId) {
		if (navigator.clipboard) {
			navigator.clipboard.writeText(poId);
		}
		else if (window.clipboardData) {
			window.clipboardData.setData("Text", poId);
		}
		else {
			const textArea = document.createElement("textarea");
			textArea.value = poId;
			const copyToClipboardContainer = document.getElementById("copyToClipboardContainer");
			copyToClipboardContainer.appendChild(textArea);
			textArea.focus();
			textArea.select();

			document.execCommand('copy');

			copyToClipboardContainer.removeChild(textArea);
		}

		showToastrSuccess("PO-id is gekopieerd naar klembord.");
	}

	editSportclub(id, isNew, isReadonly) {
		const ajaxActions = this.context.props.ajaxActions;
		const federatieId = this.context.props.federaties.length === 1 ? this.context.props.federaties[0].id : this.context.state.selectedFederatieId;

		transactionApi.getNewOrExistingTransactie(TransactionDomainEnum.SPORTORGANISATIE, id, federatieId, isReadonly)
			.then((response) => {
				ajaxActions.ended();

				this.redirectToEditSportclub(id, response.data, isNew, isReadonly);
			})
			.catch((ex) => {
				ajaxActions.failed();
			});
	}

	redirectToEditSportclub(id, transactieId, isNew, isReadonly) {
		const context = this.context;
		context.props.setActiveSportclub(id, transactieId, isReadonly, isNew);

		redirector.goTo(`/sportorganisatie/organisatie/${transactieId}`);
	}

	deleteSportclub(id) {
		const context = this.context;
		const props = context.props;
		const ajaxActions = context.props.ajaxActions;
		const federatieId = props.federatieId;

		ajaxActions.started();

		federatieApi.requestUnlinkSportclub(federatieId, id)
			.then(() => {
				ajaxActions.ended();
				this.loadSportclubPage(1, "Name");
				this.loadOpenAanvragen();
			})
			.catch(() => {
				ajaxActions.failed();
			});

		context.setState({
			deleteModalIsOpen: false
		});
	}
	linkSportclub(id) {
		const context = this.context;
		const props = context.props;
		const ajaxActions = context.props.ajaxActions;
		const federatieId = props.federatieId;

		ajaxActions.started();

		federatieApi.requestLinkSportclub(federatieId, id)
			.then((response) => {
				ajaxActions.ended();
				redirector.goTo(`/sportorganisatie/organisatie/${response.data.transactionId}`);
			})
			.catch(() => {
				ajaxActions.failed();
			});

		context.setState({
			deleteModalIsOpen: false
		});
	}
	openDeleteModal(sportclub) {
		const context = this.context;
		context.setState({
			deleteModalIsOpen: true,
			modalSportclub: sportclub
		});
	}

	closeDeleteModal() {
		const context = this.context;
		context.setState({
			deleteModalIsOpen: false,
			modalSportclub: null
		});
	}

	openCancelModal(transactie) {
		const context = this.context;
		context.setState({
			cancelModalIsOpen: true,
			modalTransactie: transactie
		});
	}

	closeCancelModal() {
		const context = this.context;
		context.setState({
			cancelModalIsOpen: false,
			modalTransactie: null
		});
	}

	openExportModal() {
		const context = this.context;
		context.setState({
			exportModalIsOpen: true,
			federatieEmailAdres: context.props.federatieEmailAdres
		});
	}

	closeExportModal() {
		const context = this.context;
		context.setState({
			exportModalIsOpen: false
		});
	}

	exportSportclubs() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const props = context.props;
		const ondernemingsnummer = props.federatieOndernemingsnummer;
		let email = context.state.federatieEmailAdres;

		if (email) {
			federatieApi.createExportRequestForSportclubs({ ondernemingsnummer: ondernemingsnummer, email: email })
				.then(() => {
					ajaxActions.ended();
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex);
				});
		}

		context.setState({
			exportModalIsOpen: false
		});
	}

	search() {
		this.loadSportclubPage(1, "Name");
	}

	change(event) {
		const property = event.target.name;
		const value = event.target.value;
		const context = this.context;
		let filter = context.state.filter;

		if (property in filter) {
			if (property === "poid") {
				filter.naam = null;
				filter.locatie = null;
				filter.sporttak = null;
			}
			else {
				filter.poId = null;
			}

			filter[property] = value;

			context.setState({
				filter: filter,
				nameFilterHasFocus: false
			});
		}
		else {
			context.setState({
				[property]: value,
				filter: {
					pageNo: 1,
					pageSize: 20,
					orderBy: "Name",
					ascending: true,
					naam: null,
					locatie: null,
					sporttak: null,
					vCode: null,
					poId: null,
					nameFilterHasFocus: false,
					telefoonorgsm:null,
					website:null,
					email:null,
					ondernemingsnummer: null
				}
			}, () => {
				if (property === "selectedFederatieId") {
					this.setFederatie();
				}
			});
		}
	}

	link() {
		redirector.goTo("/federatie/linkOrganisatie");
	}

	cancelLink(transactionId) {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		ajaxActions.started();

		transactionApi.cancelTransaction(transactionId)
			.then(() => {
				this.loadSportclubPage(1, "Name");
				this.loadOpenAanvragen();
				ajaxActions.ended();
			})
			.catch(() => {
				ajaxActions.failed();
			});

		context.setState({
			cancelModalIsOpen: false
		});
	}

	scrollToAanvragen() {
		document.getElementById("aanvragenForm").scrollIntoView();
	}
}
